const useGrantsRegion = (grant) => {
    var _a, _b;
    const { country } = grant;
    const grant_cities = (_a = grant.grant_cities) !== null && _a !== void 0 ? _a : [];
    const grant_provinces = (_b = grant.grant_provinces) !== null && _b !== void 0 ? _b : [];
    if (grant_provinces.length > 4) {
        return country;
    }
    if (grant_provinces.length > 1 || grant_cities.length > 3) {
        return [...grant_provinces, country].filter((itm) => !!itm).join(', ');
    }
    if (grant_cities.length > 1) {
        return [...grant_cities, ...grant_provinces]
            .filter((itm) => !!itm)
            .join(', ');
    }
    return [...grant_cities, ...grant_provinces, country]
        .filter((itm) => !!itm)
        .join(', ');
};
export default useGrantsRegion;
